import React, { useEffect, useRef } from 'react';

import { isEmpty } from 'lodash';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { RenewalEntriesType } from '@/api/types/renewal';
import RenewalEntry from '@/pageComponents/Home/RenewalEntry';

import style from './style.module.scss';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

interface IProps {
  data: RenewalEntriesType[];
  studentType?: string;
  dsSource?: string;
}

const RenewalBanner = (props: IProps) => {
  const { data, studentType, dsSource } = props;
  const swiperRef: any = useRef();
  useEffect(() => {
    let timer = null as any;
    if (data && data?.length > 1) {
      timer = setTimeout(() => {
        if (swiperRef.current && swiperRef.current.autoplay) {
          swiperRef.current.autoplay.start(); // 手动启动
        }
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [swiperRef.current, data]);

  if (isEmpty(data)) {
    return null;
  }

  return (
    <Swiper
      loop={data?.length > 1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
      modules={data?.length === 1 ? [] : [Pagination, Autoplay]}
      initialSlide={0}
      className={style.renewalBanner}
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
    >
      {data?.map((activity, index) => {
        return (
          <SwiperSlide key={activity?.activityId}>
            <RenewalEntry data={activity} dsSource={dsSource} studentType={studentType} rank={index} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default RenewalBanner;
